<template>
    <div class="instant-container">
        <div
            v-for="method in normalizedMethods.slice(0, 3)"
            :key="method.id"
            class="payment-pill"
            @click="$emit('pay', method.id)"
        >
            <img :src="method.transparent_images.main.src" :alt="method.name" />
        </div>
    </div>
</template>

<script>
export default {
    emits: ['pay'],
    props: {
        paymentMethods: {
            type: [Array, Object],
            required: true
        }
    },
    computed: {
        normalizedMethods() {
            if (Array.isArray(this.paymentMethods)) {
                return this.paymentMethods;
            } else if (this.paymentMethods && typeof this.paymentMethods === 'object') {
                return Object.values(this.paymentMethods);
            }
            return [];
        }
    }
};
</script>

<style scoped lang="scss">
.instant-container {
    display: flex;
    align-items: center;
    gap: 10px;
    @media only screen and (max-width: 1200px) {
        justify-content: flex-end;
        width: 100%;
    }

    .payment-pill {
        width: 70px;
        height: 34px;
        background-color: #F1F1F1;
        border-radius: 44px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        @media only screen and (max-width: 767px) {
            width: 50px;
            height: 38px;
            border-radius: 8px;
        }
        img {
            height: 100%;
            object-fit: cover;
            width: 100%;
            @media only screen and (max-width: 767px) {
                height: auto;
            }
        }
    }
}
</style>